/**
 * Dependencies.
 */
import { BaseModel, endpoint, prop } from '@prz-dp/services';

/**
 * Model `AddressReverseModel`.
 */
@endpoint('address/coordinates/reverse')
export default class AddressReverseModel extends BaseModel {
  /**
   * Properties.
   */
  @prop()
  addresses: {
    additionalInformation?: string;
    city?: string;
    countryCode?: string;
    countryName?: string;
    doorNumber?: number;
    latitude?: number;
    longitude?: number;
    street?: string;
    zipCode?: string;
  }[];

  /**
   * Constructor.
   */
  constructor(data: Partial<AddressReverseModel>) {
    super(data);
  }
}
